module.exports = __webpack_public_path__ + "img/nav-workspace-icon.cc324285.svg";